<div class="main-container">
    <section class="visual-section" #parallaxScene id="parallax-container" (contextmenu)="$event.preventDefault()">
        <div class="logo-wrapper">
            <img src="/images/newLogin/Logo_V1_light.png" alt="Gity Logo" class="brand-logo">
            <span class="beta-text">.Beta Version</span>
        </div>

        <div class="parallax-scene">
            <img src="/images/newLogin/loginComp3_V2.png" class="layer layer-monitor">
            <img src="/images/newLogin/loginComp2_V2.png" class="layer layer-anatomy">
            <img src="/images/newLogin/loginComp1_V2.png" class="layer layer-dental">
        </div>

        <div class="footer-copyright">
            GIACOMO CANNIZZARO © 2026 — ALL RIGHTS RESERVED
        </div>
    </section>

    <div class="w-100 d-flex justify-content-center align-items-center" style="background: #FAF9F9;max-width: 440px;"
        (contextmenu)="$event.preventDefault()">
        <div style="max-width: 440px;" class="loginFormMain w-100 px-5 py-3" *ngIf="displayLogin">
            <div class="d-flex  justify-content-center w-100 mb-5 mobile-logo">
                <img src="./images/uiConcept/Logos/Dark/Logo_V2_Dark.png" alt="" class="w-100"
                    style="max-width: 130px;">
            </div>
            <div class="d-flex align-items-start justify-content-center flex-column" style="gap:8px;">
                <h1 class="m-0" style="font-weight: 600;font-size: 32px;color: #000000;">Welcome Back!</h1>
                <p style="font-size: 400;font-weight: 16px;color: #707070;">Login to your Gity Account</p>
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="w-100 d-flex gap-5 justify-content-around"
                style="max-width: 1200px;">
                <div class="d-flex flex-column gap-4 align-items-center w-100">
                    <!-- <label for="" class="display-5">Login</label> -->
                    <label class="d-flex flex-column w-100 gap-1" for="username">
                        <span class="inputLabels">Username</span>
                        <input class="customInputFields" type="text" id="username" formControlName="username"
                            placeholder="" autofocus>
                    </label>

                    <label class="d-flex flex-column w-100 gap-1" for="password">
                        <span class="inputLabels">Password</span>
                        <input class="customInputFields" type="password" id="password" formControlName="password"
                            placeholder="">
                    </label>
                    <button class="loginButton" type="submit">Login</button>
                </div>
            </form>

            <div class="w-100 text-center">
                <a class="text-decoration-none"
                    style="font-size: 16px;letter-spacing: 0%; color: #707070; font-weight: 500;"
                    href="javascript:void(0)" (click)="reset()">Forgot password</a>
            </div>

            <div class="d-flex flex-nowrap align-items-center gap-2">
                <hr class="w-100" style="color:#c9c9c9;height: 1px;">
                <p class="w-100 text-center m-0 text-nowrap"
                    style="font-size: 16px;letter-spacing: 0%; color: #707070; font-weight: 500;">Or continue with
                </p>
                <hr class="w-100" style="color:#c9c9c9;height: 1px;">
            </div>

            <div class="d-flex justify-content-center py-2 w-100">
                <button (click)="loginWithGoogle()" class="w-100 d-flex gap-2 justify-content-center gap-2"
                    style="color: #FFFFFF;border:1.5px solid #E4E4E4;border-radius: 8px;background: white; padding: 12px 16px;">
                    <img src="./images/GoogleLogo.png" alt="" class="w-100" style="max-width: 24px;">
                    <span class="text-nowrap" style="font-weight: 400;font-size: 16px; color:#000000; ">Sign in with
                        Google</span>
                </button>
            </div>

            <div class="d-flex justify-content-center gap-1">
                Don't have an account?
                <a class=" text-decoration-none" style="color:#5ECDA7;font-weight: 500;font-size: 16px;"
                    href="javascript:void(0)" (click)="navigateToSignup()">Register</a>

            </div>

        </div>
    </div>
</div>

<div class="spinner-overlay" *ngIf="dataService.progressBarActive">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<!-- <script>
    // Parallax Movement Script
    const scene = document.getElementById('parallax-container');
    const layers = document.querySelectorAll('.layer-monitor, .layer-anatomy, .layer-dental');

    window.addEventListener('scroll', () => {
        console.log('window scroll');
    });
    scene.addEventListener('mousemove', (e) => {
        // Calculate mouse position relative to center of screen
        const x = (window.innerWidth / 2 - e.pageX);
        const y = (window.innerHeight / 2 - e.pageY);

        layers.forEach(layer => {
            console.log({ layers });
            const depth = layer.getAttribute('data-depth');
            const moveX = x * depth;
            const moveY = y * depth;

            // Apply the transform
            layer.style.setProperty('--parallaxX', `${moveX}px`);
            layer.style.setProperty('--parallaxY', `${moveY}px`);
        });
    });
</script> -->